// roomsSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const roomsSlice = createSlice({
  name: 'rooms',
  initialState: {
    rooms: [],  // Ensure that rooms is an empty array
  },
  reducers: {
    setRooms: (state, action) => {
      state.rooms = action.payload; // Update the rooms array
    },
  },
});

export const { setRooms } = roomsSlice.actions;

export default roomsSlice.reducer;

